import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#232536',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#ffcf51',
      contrastText: '#232536',
    },
    background: {
      default: '#f9fafb',
      paper: '#ffffff',
    },
    text: {
      primary: '#232536',
      secondary: '#4b5563',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
});
